// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { Validator } from 'vee-validate'

Validator.extend('youtubeLink', {
  getMessage: () => '',
  validate: value => /(?:src="|^)https:\/\/www\.youtube\.com\/embed\/([a-zA-Z0-9]+)(?="|$)/.test(value)
})

require('./plugins/validation')
require('./plugins/localstorage')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js